// extracted by css-extract-rspack-plugin
export default {"Eyebrow":"Eyebrow-module__Eyebrow__Mowfe","Icon":"Eyebrow-module__Icon__lPPSB"};